import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import { Person, useClient } from './clientSettingsData';
import SettingsModal from './SettingsModal';

interface Props {
    person: Person;
    onClose: () => void;
    onRemove: (person: Person) => void;
}

const RemoveUserModal: React.FC<Props> = ({ person, onClose, onRemove }) => {
    const { short } = useClient();
    return <SettingsModal danger icon={<FiTrash2 />} title={`Remove ${person.name}'s Access?`} sub={`${person.organisation} · ${person.role} on ${short}`} onClose={onClose}
        footer={<button type="button" className="btn-danger" onClick={() => onRemove(person)}><FiTrash2 /> Remove Access</button>}>
        <ul className="bullets">
            <li>They lose access to {short} immediately. Other clients are not affected.</li>
            <li>Anything they wrote — answers, articles, campaigns — stays and keeps their name.</li>
            <li>They keep receiving investor emails if they are also a subscriber.</li>
        </ul>
    </SettingsModal>;
};

export default RemoveUserModal;
